function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M22.875 11.5C19.8589 11.5 17.2972 8.33312 16.3522 7C17.2972 5.66688 19.8589 2.5 22.875 2.5C25.3568 2.5 27.375 4.51825 27.375 7C27.375 9.48175 25.3568 11.5 22.875 11.5ZM7.125 11.5C4.64325 11.5 2.625 9.48175 2.625 7C2.625 4.51825 4.64325 2.5 7.125 2.5C10.1411 2.5 12.7028 5.66688 13.6478 7C12.7028 8.33312 10.1411 11.5 7.125 11.5ZM22.875 0.25C19.2705 0.25 16.413 3.22562 15 5.047C13.587 3.22562 10.7295 0.25 7.125 0.25C3.40237 0.25 0.375 3.27737 0.375 7C0.375 10.7226 3.40237 13.75 7.125 13.75C10.7295 13.75 13.587 10.7744 15 8.953C16.413 10.7744 19.2705 13.75 22.875 13.75C26.5976 13.75 29.625 10.7226 29.625 7C29.625 3.27737 26.5976 0.25 22.875 0.25Z"
});

function SvgIcAreaInfinity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 14,
    viewBox: "0 0 30 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAreaInfinity);
export default ForwardRef;